import * as THREE from 'three';
import 'hammerjs';



require('../../utils/animationapi.js');

export default class CameraManager {

    constructor(config) {

        let self = this;
        let defaultConfig = {
            slurp:(window.innerWidth < 600)? 25:20, // how much friction there is when animating the camera
            max_speed:300,
            depth:24000,
            touch_multiplier:6, // hammer touch / pointer imput
            mouse_multiplier: 4, // scroll input
            camera_offset: (window.innerWidth < 600)? {x: 0, y: 1000, z: -2000} : {x: 0, y: 1000, z: -1800}// vector describing the position offset from any target object
        };

        this.config = deepmerge(defaultConfig, config);

        this.camera = this.makeCamera(config);

        this._targetX = 0;
        this._targetY = 0;
        this._targetZ = 0;
        this.scrolling = false;

        var mc = new Hammer(document.getElementById('Timeline'));
        var world = this;
        mc.get('swipe').set({ direction: Hammer.DIRECTION_VERTICAL });

        mc.on("swipeup", function(ev) {

            world.checkVerticalPan(-1);

        });
        mc.on("swipedown", function(ev) {
            world.checkVerticalPan(1);


        });

        document.body.addEventListener( 'touchmove', this.onDocumentTouchMove.bind(this), {passive: false} );
        document.body.addEventListener( 'touchmove', this.onDocumentTouchMove.bind(this), {passive: false} );
        if($(window).width() >= 700){document.body.addEventListener('mousemove', this.onDocumentMouseMove.bind(this), false);}

        this.addEvent(document.body, 'mousewheel', this.checkScroll.bind(this), { capture: false, passive: true});
        this.addEvent(document.body, 'DOMMouseScroll', this.checkScroll.bind(this), { capture: false, passive: true});
        this.addEvent(document.body, 'wheel', this.checkScroll.bind(this), { capture: false, passive: true});
        this.addEvent(document.body, 'MozMousePixelScroll', this.checkScroll.bind(this), { capture: false, passive: true});


        this.intID = setInterval(function(){
            if(self.scrolling == true) {
                self.scrolling = false;
                self.emitEvent({
                    type: 'position',
                    data: self._targetZ
                });
            }
        }, 300);

        return this;

    }

    set targetY(y){
        this._targetY = y;
    }

    get targetY(){
        return this._targetY;
    }

    set targetX(x){
        this._targetX = x;
    }

    get targetX(){
        return this._targetX;
    }

    set targetZ(z){

        if((this._targetZ + z) < 0 || (this._targetZ + z) > this.config.depth) z = 0;
        this._targetZ += z;

    }

    get targetZ(){
        return this._targetZ;
    }

    set camera(cam){
        this._camera = cam;
    }

    get camera(){
        return this._camera;
    }

    emitEvent(data){
        document.dispatchEvent(new CustomEvent("camera_event",
            {
                detail: {
                    data
                }
            }));
    }

    makeCamera(config){

        let cam   = new THREE[config.default.type](config.default.config.fov, config.default.config.ratio, config.default.config.drawNear, config.default.config.drawFar);
        this.defaultPos  = new THREE.Vector3(config.default.config.posX, config.default.config.posY, config.default.config.posZ);
        this.defaultTarget = new THREE.Vector3(config.default.config.targetX, config.default.config.targetY, config.default.config.targetZ);

        cam.lookAt( this.defaultTarget );

        this.dolly = new THREE.Object3D();
        this.dolly.add(cam);

        this.dolly.position.x = config.default.config.posX;
        this.dolly.position.y = config.default.config.posY;
        this.dolly.position.z = config.default.config.posZ;


        this.light = new THREE.AmbientLight( 0x404040, 2);
        //this.light.position.set( 0, 30000, -80000 );
        this.dolly.add(this.light);

        return cam;

    }

    set depth(depth){
        this.light.position.set( 0, depth - 4000, -8000 );
        this.config.depth = depth;
    }

    checkScroll(event){

        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        let rolled = 0;
        if ('wheelDelta' in event) {
            rolled = event.wheelDelta;
        } else {  // Firefox
            // The measurement units of the detail and wheelDelta properties are different.
            rolled = -40 * event.detail;
        }

        rolled *= this.config.mouse_multiplier;
        rolled = (rolled > this.config.max_speed) ? this.config.max_speed : rolled;
        rolled = (rolled < -this.config.max_speed) ? -this.config.max_speed : rolled;
        this.targetZ = rolled;
        this.scrolling = true;

    }

    checkVerticalPan(event){

        let move = 500 * event * 3;
        this.targetZ = move;
        this.scrolling = true;

    }



    onDocumentMouseMove(event) {

        this.targetX = event.clientX - (window.innerWidth / 2);
        this.targetY = (event.clientY - (window.innerHeight / 2)) * .8;

    }

    onDocumentTouchMove(event) {

        event.preventDefault();

        if(window.innerWidth > 600){
            event.clientX = (event.touches[0].clientX - (window.innerWidth / 2)) * this.config.touch_multiplier;
            event.clientY = (event.touches[0].clientY - (window.innerHeight / 2)) * 2;
            this.onDocumentMouseMove(event);
        }

    }

    update(){

        let currx   = this.dolly.position.x;
        let targetx = currx + ((this.targetX - currx) / this.config.slurp);

        let curry   = this.dolly.position.y;
        let targety = curry + (((this.targetY + this.config.camera_offset.y) - curry) / this.config.slurp);

        let currz   = this.dolly.position.z;
        let targetz = currz + (((this.targetZ + this.config.camera_offset.z) - currz) / this.config.slurp);

        this.dolly.position.x = targetx;
        this.dolly.position.y = targety;
        this.dolly.position.z = targetz;

    }

    resetCam() {

        let camTargetPos = this.defaultTarget.clone();

        // clone the default view target
        let center = this.defaultPos.clone();
        let camDist = this._camera.position.distanceTo(center);
        this.animateCam(center, camDist, function () {
        });
        this.animateTarget(camTargetPos);

    }


    addEvent(el, eventType, handler) {
        if (el.addEventListener) { // DOM Level 2 browsers
            el.addEventListener(eventType, handler, {passive:false});
        } else if (el.attachEvent) { // IE <= 8
            el.attachEvent('on' + eventType, handler);
        } else { // ancient browsers
            el['on' + eventType] = handler;
        }
    };

}



